import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

export class ZIDXAccountPaymentCancel implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountPaymentCancelContainer";
    }
    render(){
        // console.log("payment cancel");
    }
}